import { render, staticRenderFns } from "./ProgramCourses.vue?vue&type=template&id=ffb43c96"
import script from "./ProgramCourses.vue?vue&type=script&lang=js"
export * from "./ProgramCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports